import './style.css'
import MonthSlider from "../../modules/month-slider";
import {Button, TextareaAutosize} from "@mui/material";
import ConfirmModal from "../../components/confirm-modal";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {
    deleteTicker,
    getAllChanels,
    getDayTicker, getDayTickerText,
    getMonthTicker, setUpdatePositionTicker, setUpdateTickerFile
} from "../../API/api";
import LabelBrand from "../../components/label-brand";
import BtngroupEditDelete from "../../components/btngroup-edit-delete";
import {ArrowDownward, ArrowUpward} from "@mui/icons-material";
import SetpositionMplist from "../../modules/setposition-mplist";

const TickerPage = () =>{
    const {activeMonth} = useSelector((store) => store.month);
    const {activeChanel} = useSelector((store) => store.chanel);
    const monthName = (date) => (new Date(Date.parse(date)).toLocaleString('ru', {
        month: 'long', year: 'numeric'
    }))
    const navigate = useNavigate();

    const month = monthName(activeMonth)

    const [chanels, setChanels] = useState([])
    const getChanels = async () => {
        const data = await getAllChanels();
        setChanels(data)
    }
    useEffect(() => {
        getChanels();
    },[]);


    // Confirm Modal
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [deleteId, setDeleteId] = useState('')

    const ConfirmModalOpen = (id) => {
        setOpenConfirmModal(true);
        setDeleteId(id)
    };

    //Проверить для отображения дней скопировал.
    const [dayPerMonth, setDayPerMonth] = useState([])
    const [currentDay, setCurrentDay] = useState(null)
    const currentDays = () => {
        setDayPerMonth([])
        const lastDayMonth = new Date(
            new Date(activeMonth).getFullYear(),
            new Date(activeMonth).getMonth()+1, 0).getDate()
        for (let i = 1; i <= lastDayMonth; i++) {
            setDayPerMonth(oldArray => [...oldArray, i])
        }
    }
    useEffect(() => {
        currentDays()
    }, [activeMonth])
    // Get name Day of week
    const getWeekDay = (date) => {
        let days = ['ВС', 'ПН', 'ВТ', 'СР', 'ЧТ', 'ПТ', 'СБ'];

        return days[date.getDay()];
    }

    //Получаем дынные
    const [tickerList, setTickerList] = useState([])
    //Месяц
    const getTickerList = async () => {
        if (chanels.length > 0) {
            if (!currentDay) {
                const data = await getMonthTicker(localStorage.getItem("access_token"),`${month}`, `${chanels[activeChanel]?.id}`)
                setTickerList(data)
            }
            if (currentDay) {
                const data = await getDayTicker(localStorage.getItem("access_token"),`${month}`, `${chanels[activeChanel]?.id}`, `${currentDay}`)
                setTickerList(data)
            }
        }
    }
    useEffect(() => {
        getTickerList();
    },[chanels, activeMonth, activeChanel, currentDay]);

    const deleteSelectTicker = async (id) => {
        await deleteTicker(localStorage.getItem("access_token"), id)
        getTickerList()
    }

    // Проверка получения текста бегушки:
    const [tickerTextList, setTickerTextList] = useState([])
    //Месяц
    const getTickerTextList = async () => {
        if (chanels.length > 0) {
                const data = await getDayTickerText(
                    localStorage.getItem("access_token"),
                    `${month}`,
                    `${chanels[activeChanel]?.id}`,
                    `${currentDay}`
                )
            setTickerTextList(data)
        }
    }
    useEffect(() => {
        getTickerTextList();
    },[chanels, activeMonth, activeChanel, currentDay]);

    const updateTickerFile = async () => {
        try {
            await setUpdateTickerFile(localStorage.getItem("access_token"), chanels[activeChanel]?.id)
            alert(`Файл бегущей строки успешно обновлен!`)
            // navigate('/ticker')
        } catch (error) {
            console.dir(error);
            throw new Error("Что-то не так с пост запросом");
        }
    }

    //Change Position
    const positionUp = async (index) => {
        await setUpdatePositionTicker(localStorage.getItem("access_token"),
            tickerList?.[index].id, {position: tickerList?.[index - 1].position})
        await setUpdatePositionTicker(localStorage.getItem("access_token"),
            tickerList?.[index - 1].id, {position: tickerList?.[index]?.position})
        await getTickerList();
    }
    const positionDown = async (index) => {
        await setUpdatePositionTicker(localStorage.getItem("access_token"),
            tickerList?.[index].id, {position: tickerList?.[index + 1].position})
        await setUpdatePositionTicker(localStorage.getItem("access_token"),
            tickerList?.[index + 1].id, {position: tickerList?.[index]?.position})
        await getTickerList();
    }

    //Функция подсветки закончившихся бегухи
    const setColor = (lastDay) => {
        if (month === monthName(new Date())) {
            if (new Date().getDate() === lastDay) {
                return 'blue'
            }
            if (new Date().getDate() + 1 === lastDay) {
                return 'yellow'
            }
            if (new Date().getDate() > lastDay) {
                return 'red'
            }
            else {return ''}
        }
    }

    return (
        <div className="ticker-page container">
            <MonthSlider />
            <div className="pagination-list">
                <Button variant="contained" onClick={() => setCurrentDay(null)}>Весь МЕСЯЦ</Button>
            </div>
            <div className="pagination-list">{dayPerMonth.map((el) =>
                <p key={el} className={el === currentDay ? "active-pagination" :
                    `${getWeekDay(new Date(new Date(activeMonth).getFullYear(), new Date(activeMonth).getMonth(), el)) === "СБ" ||
                    getWeekDay(new Date(new Date(activeMonth).getFullYear(), new Date(activeMonth).getMonth(), el)) === "ВС" ? "weekend" : ""}`
                }
                   onClick={() => setCurrentDay(el)}
                >
                    {el}
                </p>)}
            </div>
            <div className="pagination-list" style={{marginTop:"-33px"}}>{dayPerMonth.map((el) =>
                <p key={el} className={el === currentDay ? "active-pagination" :
                    `${getWeekDay(new Date(new Date(activeMonth).getFullYear(), new Date(activeMonth).getMonth(), el)) === "СБ" ||
                    getWeekDay(new Date(new Date(activeMonth).getFullYear(), new Date(activeMonth).getMonth(), el)) === "ВС" ? "weekend" : ""}`
                }
                   onClick={() => setCurrentDay(el)}
                >
                    {getWeekDay(new Date(new Date(activeMonth).getFullYear(), new Date(activeMonth).getMonth(), el))}
                </p>)}
            </div>
            <div className="all-mp-list">
                <span>Список активных Бегушек:</span>
                {tickerList?.map((ticker, index) =>
                    (
                        <div key={ticker.id} className={"brand-name-list"}>
                            <div style={{display:"flex",flexDirection:"column", gap:3}}>
                                <ArrowUpward
                                    style={{
                                        color:"#1565c0",
                                        width:15,
                                        fontSize:null,
                                        cursor:"pointer",
                                        display: (index === 0) ? "none": "inline-block"
                                    }}
                                    onClick={() => positionUp(index)}
                                />
                                <ArrowDownward
                                    style={{
                                        color:"#1565c0",
                                        width:15,
                                        fontSize:null,
                                        cursor:"pointer",
                                        display: (index === tickerList.length - 1) ? "none": "inline-block"
                                    }}
                                    onClick={() => positionDown(index)}
                                />
                            </div>
                            <div>
                                <SetpositionMplist
                                    id={ticker.id}
                                    positionValue={ticker.position}
                                    getMpList={getTickerList}
                                    updatePosition={setUpdatePositionTicker}
                                />
                            </div>
                            <LabelBrand
                                brandName={ticker.name}
                                color={setColor(ticker.days.at(-1))}
                            />
                            <BtngroupEditDelete
                                editLink={() => navigate(`/ticker/editTicker/${ticker.id}`)}
                                deleteLink={() => ConfirmModalOpen(ticker.id)}
                            />
                            <span>До {ticker.days.at(-1)} {month}</span>
                        </div>
                    )
                )}
            </div>
            <div className="btn-add-mp">
                <Button variant="contained" onClick={() => navigate('/ticker/addTicker')}>Добавить Бегуху</Button>
                <Button variant="outlined" onClick={() => updateTickerFile()}>Обновить файл</Button>
            </div>
            <div className="all-mp-list">
                {currentDay &&
                    <TextareaAutosize
                        className="ticker-textaria"
                        placeholder="Текст бегущей строки"
                        maxRows={10}
                        value={tickerTextList.map((item) => {
                                if (Array.isArray(item)) {
                                    return item.join('\n')
                                }
                                return item
                            }).join('\n')}
                    />
                }
            </div>
            <ConfirmModal
                openConfirmModal={openConfirmModal}
                setOpenConfirmModal={setOpenConfirmModal}
                link={() => deleteSelectTicker(deleteId)}
            />
        </div>
    )
}

export default TickerPage